import styled from '@emotion/styled';
import { alpha } from '@mui/material/styles';

type FullWidthProps = { $fullWidth?: boolean };

const withoutFullWidth = { shouldForwardProp: (prop: string) => prop !== '$fullWidth' };

export const StyledContainer = styled(
  'div',
  withoutFullWidth,
)<FullWidthProps>(({ $fullWidth }) => ({
  display: $fullWidth ? 'flex' : 'inline-flex',
  width: $fullWidth ? '100%' : undefined,
  alignItems: 'center',
  gap: 8,
}));

export const StyledGroup = styled(
  'div',
  withoutFullWidth,
)<FullWidthProps>(({ $fullWidth }) => ({
  display: $fullWidth ? 'flex' : 'inline-flex',
  flex: $fullWidth ? '1 1 0' : undefined,
  minWidth: 0,
  alignItems: 'center',
  gap: 4,
}));

export const StyledDivider = styled('span')(({ theme }) => ({
  width: 20,
  height: 1,
  flexShrink: 0,
  backgroundColor: theme.colors.border.default,
}));

export const StyledCell = styled('input', {
  shouldForwardProp: (prop) => prop !== '$error' && prop !== '$fullWidth',
})<{ $error?: boolean } & FullWidthProps>(({ theme, $error, $fullWidth }) => ({
  width: $fullWidth ? 'auto' : 38,
  minWidth: 0,
  height: 52,
  flexGrow: $fullWidth ? 1 : 0,
  flexShrink: $fullWidth ? 1 : 0,
  flexBasis: $fullWidth ? 0 : 'auto',
  textAlign: 'center',
  fontFamily: 'DM Sans, sans-serif',
  fontSize: 16,
  fontWeight: 500,
  lineHeight: '24px',
  fontVariantNumeric: 'tabular-nums',
  color: theme.colors.text.primary,

  backgroundColor: theme.colors.background.overlay,
  border: `1px solid ${$error ? theme.colors.error.border : theme.colors.border.default}`,
  borderRadius: theme.radius[8],

  outline: 'none',
  boxSizing: 'border-box',
  padding: '4px 12px',
  margin: 0,
  cursor: 'text',
  transition: 'border-color 0.15s ease, box-shadow 0.15s ease',

  '&::placeholder': {
    color: theme.colors.text.secondary,
  },

  '&:hover:not(:disabled):not(:focus)': {
    borderColor: theme.colors.border.strong,
  },

  '&:focus': {
    borderColor: $error ? theme.colors.error.border : theme.colors.border.default,
    boxShadow: $error
      ? `inset 0 0 0 2px ${alpha(theme.colors.error.solid, 0.2)}`
      : `inset 0 0 0 2px ${theme.colors.border.focus}`,
  },

  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
    pointerEvents: 'none',
  },
}));
